/** 
 * Set focus on search input field
 * when dropdown pane or off-canvas panel opens
 */

import $ from 'jquery';

function focusGoogleInput(container) {
  // Wait until Google CSE has rendered its input
  setTimeout(function() {
    let googleInput = container.querySelector('.gsc-input input');
    if (googleInput) {
      googleInput.focus();
    }
  }, 200); // small delay to ensure CSE markup is in place
}

function blurGoogleInput(container) {
  let googleInput = container.querySelector('.gsc-input input');
  if (googleInput) {
    googleInput.blur();
  }
  let closeButton = container.querySelector('.close-button');
  if (closeButton) closeButton.blur();
}

$(document)
  .on('show.zf.dropdown openedEnd.zf.offCanvas', '#dropdown-search-bar, #off-canvas-search-panel', function(e) {
    // Focus on input
    focusGoogleInput(e.currentTarget);

    // Show page overlay
    // $('.menu-page-overlay').fadeIn(300);
  })
  .on('hide.zf.dropdown close.zf.offCanvas', '#dropdown-search-bar, #off-canvas-search-panel', function(e) { 
    // Blur input
    blurGoogleInput(e.currentTarget);

    // Hide page overlay
    // document.querySelector('.menu-page-overlay').style.display = 'none';
  });

// Change focus on search type paddle switch change (styled checkbox)
const searchType = document.querySelector('#search-type');
if (searchType) {
  searchType.addEventListener('change', function() {
    if (this.checked) document.querySelector('#search-type-directory #ds-firstname').focus();
    else document.querySelector('#search-type-google .gsc-input input').focus();
  });
}